import { head } from 'ramda'

import { useForm } from '../../../../packages/kiti/components/form/form/FormHandler'
import { useScreens } from '../_load/ScreensLoader'

export const useDashActiveTab = () => {
  const tabs = useScreens()
  const { activeTabIndex } = useForm() || {}
  return tabs[activeTabIndex] || head(tabs)
}
